import React, { useState } from 'react';

import { styled } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';

import CustomExpandIcon from './CustomExpandIcon';

const AccordionSummaryContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

const AccordionContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

const CustomAccordion = ({
  title,
  expandIconVariant,
  children,
  onChange,
  className,
  accordionContentClassName,
  ...props
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const handleChange = (e) => {
    if (!e.target.closest('.prevent-accordion')) {
      setIsAccordionOpen(!isAccordionOpen);
      onChange(!isAccordionOpen);
    }
  };

  return (
    <Accordion
      className={className}
      onChange={handleChange}
      expanded={isAccordionOpen}
      {...props}
    >
      <AccordionSummary
        expandIcon={<CustomExpandIcon variant={expandIconVariant} />}
      >
        <AccordionSummaryContent>{title}</AccordionSummaryContent>
      </AccordionSummary>
      <AccordionDetails>
        <AccordionContent className={accordionContentClassName}>
          {children}
        </AccordionContent>
      </AccordionDetails>
    </Accordion>
  );
};

export default CustomAccordion;
